/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useEffect } from "react";
import HeaderSection from "../../../common/headerSection";
import PageHeader from "../../../common/pageHeader";
import { Link } from "react-router-dom";
import CustomTable from "../../../../widgets/table";
import Pagination from "../../../../widgets/pagination";
import { TfiClose } from "react-icons/tfi";
import { Modal } from "react-bootstrap";
import { dashboardServices } from "../../../../service/dashboard";
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import translationData from '../../../../locales/dashboardTranslation.json'
import { useDispatch } from 'react-redux'
import DownloadPdf from "../../../../widgets/downloadPdf";
import { DEFAULT_PAGE_SIZE } from "../../../../constants/constants";
import { scheduleService } from "../../../../service/scheduleService";
import { areaService } from "../../../../service/areaServices";
import { helperFunctions as _h } from "../../../../utils/helper";

const InnerPageLabtest = () => {
    const { labtestId } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [scheduleDetails, setScheduleDetails] = useState([]);
    const displayName = getDisplayName(Number(labtestId));
    const [useEffectRequired, setUseEffectRequired] = useState(false)
    const [sort, setSort] = useState("id");
    const [order, setOrder] = useState("desc");

    // Filter states
    const [keyWord, setkeyWord] = useState("");
    const [activityTypeId, setActivityTypeId] = useState("");
    const [areaId, setAreaId] = useState("");
    const [proScheduleId, setProScheduleId] = useState("");
    const [location, setLocation] = useState("");
    const [productNameId, setProductNameId] = useState("");

    // Filter data lists
    const [activityTypeList, setActivityTypeList] = useState<Array<any>>([]);
    const [areaList, setAreaList] = useState<Array<any>>([]);
    const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
    const [locationList, setLocationList] = useState<Array<any>>([]);
    const [productList, setProductList] = useState<Array<any>>([]);
    const sortRemoveList=["labtest_third_doneby","colony_count","deviations_any","status","labtest_first_doneby","labtest_second_doneby"]

    function getDisplayName(id: any) {
        const LabtestDataHead = translationData.LabtestDataHead;
        const labtest = LabtestDataHead.find(item => item.id === id);
        return labtest ? labtest.displayName : "";
    }

    //column header for labtest view
    const baseColumns: any[] = [
      {
        Header: "tableCommon.sl_no",
        accessor: "slno",
      },
      {
        Header: "scheduleOperator.tableColumns.production_schedule",
        accessor: "production_schedule",
      },
      {
        Header: "scheduleOperator.tableColumns.product_name",
        accessor: "product_name",
      },
      {
        Header: "dashboard.labtestViewTableColumns.plateSerialNumber",
        accessor: "plate_serial_number",
      },
      {
        Header: "dashboard.labtestViewTableColumns.batchNumber",
        accessor: "batch_number",
      },
      {
        Header: "dashboard.labtestViewTableColumns.labtest1DoneBy",
        accessor: "labtest_first_doneby",
      },
      {
        Header: "dashboard.labtestViewTableColumns.labtest2DoneBy",
        accessor: "labtest_second_doneby",
      },
      {
        Header: "dashboard.labtestViewTableColumns.labtest3DoneBy",
        accessor: "labtest_third_doneby",
      },
      {
        Header: "dashboard.labtestViewTableColumns.colonyCountOrLimit",
        accessor: "colony_count",
      },
      {
        Header: "dashboard.labtestViewTableColumns.deviationsIfAny",
        accessor: "deviations_any",
      },
      {
        Header: "dashboard.labtestViewTableColumns.status",
        accessor: "status",
      },
    ];

    const extraColumns =
      ["1", "2", "3"].includes(labtestId as any) ? [
        // {
        //   Header: "scheduleOperator.tableColumns.production_schedule",
        //   accessor: "production_schedule",
        // },
        // {
        //   Header: "scheduleOperator.tableColumns.product_name",
        //   accessor: "product_name",
        // },
        {
          Header: "scheduleProduction.tableColumns.area_name",
          accessor: "area",
        },
        {
          Header: "scheduleFrequency.tableColumns.activity_type_name",
          accessor: "activity",
        },
        {
          Header: "generatePlateQr.tableColumns.location",
          accessor: "location_name",
        },
      ] : [];

    const columns = [
      ...baseColumns.slice(0, 1), // keep slno at the top
      ...extraColumns,
      ...baseColumns.slice(1),   // rest of the base columns
    ];
  
    //handle pagination 
    const handleSchedulePageChange = (newPage :any, newPageSize?: number) => {
      setPage(newPage);
      if (newPageSize) {
        setPageSize(newPageSize);  
      }
      setUseEffectRequired(true)
    };

    // function to sort table
    const handleSort = (key: string, value: boolean) => {
      setSort(key)
      if (value) {
        setOrder("asc")
      } else {
        setOrder("desc")
      }
      setUseEffectRequired(true)
    }

    //handle inner page api integration 
    const fetchData = async () => {
      try {
        let response;
        switch (labtestId) {
          case "1":
            response = await dashboardServices.ListFirstLabtest(page, pageSize, sort, order, keyWord, proScheduleId, activityTypeId, areaId, location, productNameId);
            break;
          case "2":
            response = await dashboardServices.ListSecondLabtest(page, pageSize, sort, order, keyWord, proScheduleId, activityTypeId, areaId, location, productNameId);
            break;
          case "3":
            response = await dashboardServices.ListThirdLabtest(page, pageSize, sort, order, keyWord, proScheduleId, activityTypeId, areaId, location, productNameId);
            break;
          case "4":
            response = await dashboardServices.ListReviewLabtest(page, pageSize, sort, order, proScheduleId, productNameId);
            break;
          case "5":
            response = await dashboardServices.ListPlateForFlora(page, pageSize, sort, order, proScheduleId, productNameId);
            break;
          case "6":
            response = await dashboardServices.ListLabtestWithinRange(page, pageSize, sort, order);
            break;
          case "7":
            response = await dashboardServices.ListLabtestOutsideRange(page, pageSize, sort, order);
            break;
          default:
            break;
        }
  
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              setTotalPages(response?.totalPages);
              setTotalElements(response?.totalElements);
              let rowData = response.data.map((element:any, index: any) => ({
                slno: index + 1,
                plate_serial_number: element.plate_serial_number,
                batch_number: element.plate_batch_number,
                labtest_first_doneby: element.first_lab_done_by,
                labtest_second_doneby: element.second_lab_done_by,
                labtest_third_doneby : element.third_lab_done_by,
                colony_count: element.colony_count_limit,
                deviations_any: element.deviations_any,
                status: element.status,
                production_schedule: element.production_schedule_name,
                product_name: element.product_name,
                area: element.area_name,
                activity: element.assigned_activity_name || element.activity_type_name,
                location_name: element.plate_location_name
              }));
              setScheduleDetails(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setScheduleDetails([]);
          setTotalPages(0);
          setTotalElements(0);
        }
      } catch (error) {
        console.error('API call error', error);
      }
    };

    // Get Activity Type List
    const getActivityTypeList = async () => {
      try {
        const response = await scheduleService.getActivityTypeList();
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    id: element.id,
                    name: element.name,
                  };
                }
              );
              setActivityTypeList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setActivityTypeList([]);
        }
      } catch (error) {
        console.error("user response", error);
      }
    };

    // Get Area List
    const getAreaList = async (areaType: any, gradeId: any) => {
      try {
        const response = await areaService.getAreaList(0, 0, sort, order, "", areaType, "", gradeId);
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {
                const role = element.role_master_id === "1" ?
                  "Admin" : element.role_master_id === "2" ?
                    "Operator" : element.role_master_id === "3" ?
                      "Lab Operator" : null
                const statusNumber = parseInt(element.type, 10);
                const area_type = areaService.getLocationStatus(statusNumber);

                return {
                  slno: index + 1,
                  id: element.id,
                  area_code: element.area_code,
                  name: element.name,
                  area_type: element.location_type_name,
                  status: element.status,
                  qr_image_path: element.qr_image_path,
                };
              });
              setAreaList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setAreaList([]);
        }
      } catch (error) {
        console.error('user response', error);
      }
    };

    // Get Production Schedules
    const getProductionSchedules = async (areaId: string) => {
      try {
        const response = await scheduleService.getProductionSchedules(areaId);
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    id: element.id,
                    production_schedule_name: element?.production_schedule_name,
                  };
                }
              );
              setProdScheduleList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setProdScheduleList([]);
        }
      } catch (error) {
        console.error("user response", error);
      }
    };

    // Get Location by Activity and Area
    const getLocationByActivity = async (activityId: any, areaId: any) => {
      try {
        const response = await areaService.getLocationByActivity(activityId, '', '', areaId);
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    slno: index + 1,
                    id: element.id,
                    name: element.name,
                  };
                }
              );
              setLocationList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setLocationList([]);
        }
      } catch (error) {
        console.error("user response", error);
      }
    };

    // Get Product List
    const getProductList = async () => {
      try {
        const response = await scheduleService.getProductList();
        if (response.status && response.statusCode === 200) {
          try {
            if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
                (element: any, index: number) => {
                  return {
                    id: element.id,
                    name: element.name,
                  };
                }
              );
              setProductList(rowData);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          setProductList([]);
        }
      } catch (error) {
        console.error("user response", error);
      }
    };

    // Handle filter changes
    const handleFilter = (key: string, value: any) => {
      if (key === "search") {
        setkeyWord(value);
      } else if (key === "activityType") {
        setActivityTypeId(value);
        getLocationByActivity(value, areaId);
      } else if (key === "area") {
        setAreaId(value);
        getLocationByActivity(activityTypeId, value);
        getProductionSchedules(value);
      } else if (key === "productionSchedule") {
        setProScheduleId(value);
      } else if (key === "location") {
        setLocation(value);
      } else if (key === "productName") {
        setProductNameId(value);
      }
      setUseEffectRequired(true);
    };

    useEffect(() => {
        fetchData();
        setUseEffectRequired(false)
      }, [labtestId, useEffectRequired]);

    useEffect(() => {
      // Initialize filter data
      getActivityTypeList();
      getAreaList("8,12,9,6,17", "");
      getProductList();
      getProductionSchedules("");
    }, []);

      return (
        <div>
          <HeaderSection />
          <PageHeader pageHeader={t('dashboard.title')} />
          <div id="dashWrap">
            <nav aria-label="breadcrumb" className="breadcrumb-container row">
              <div className='col-10 d-flex'>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item dashboard-hover">
                    <Link to="/*">{t('dashboard.title')}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                  {displayName}
                  </li>
                </ol>
              </div>
              <div className='col-2 d-flex'>
                <DownloadPdf divId="dashWrap" reportHead="LabTest Report" />
              </div>
            </nav>
    
            <div className='col-md-12 mx-3 pe-5' style={{"height":"45vh"}}>
                    <CustomTable
                        tableHead={displayName} 
                        data={scheduleDetails} 
                        columns={columns} 
                        isEditable={false} 
                        isActionVisible={false} 
                        isViewVisible={false} 
                        totalElements={totalElements}
                        isToggleStatus={false}
                        onSortClick={handleSort}
                        onUseEffectRequired={() => setUseEffectRequired(true)}
                        // Filter related props
                        onFilterClick={handleFilter}
                        showFullFilters={true}
                        ActivityType={activityTypeList}
                        areaDropList={areaList}
                        prodScheduleList={prodScheduleList}
                        locationList={locationList}
                        productList={productList}
                        removeSortList={sortRemoveList}       
                    />
            </div>
            <div>
                  <Pagination
                    page={page}
                    totalPages={totalPages}
                    handlePageChange={handleSchedulePageChange}
                  />
            </div>
          </div>
        </div>
      );
  };
  
  export default InnerPageLabtest;